var _circle, _path, _path2, _path3, _path4, _path5, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCostControl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    fill: "#f9cc10",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 1 1 1v6l-1 1c-11.61 0-21 9.39-21 21 0 4.15 1.2 8.02 3.29 11.27l-.148 2.095-4.142 2.635-2.47-.43c-2.87-4.5-4.53-9.83-4.53-15.57 0-16.03 12.97-29 29-29z",
    fill: "#18b4ea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m44.94 5.14 1.063 1.86-3.003 5h-2.18c-3.15-1.91-6.86-3-10.82-3v-8c5.47 0 10.58 1.51 14.94 4.14z",
    fill: "#f9cc10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m57.63 21.16-.63.919-6 1.921-.99-.4c-1.56-4.89-4.87-9.01-9.19-11.6l4.12-6.86c5.97 3.59 10.53 9.26 12.69 16.02z",
    fill: "#ed4545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m59 30c0 12.11-7.41 22.48-17.95 26.81l-2.05-.81-2.064-5 1.064-1.58c7.64-3.14 13-10.64 13-19.42 0-2.23-.35-4.38-.99-6.4l7.62-2.44c.89 2.79 1.37 5.76 1.37 8.84z",
    fill: "#6d45db"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41.05 56.81c-3.4 1.42-7.13 2.19-11.05 2.19-10.3 0-19.33-5.35-24.47-13.43l6.76-4.3c3.71 5.85 10.25 9.73 17.71 9.73 2.83 0 5.54-.56 8-1.58z",
    fill: "#8dd35f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ef9d0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31 29.223v-5.13c1.7.287 3 1.268 3 2.407 0 .553.447 1 1 1s1-.447 1-1c0-2.267-2.129-4.087-5-4.435v-1.065c0-.553-.447-1-1-1s-1 .447-1 1v1.065c-2.871.348-5 2.168-5 4.435 0 2.739 2.605 3.653 5 4.277v5.13c-1.7-.287-3-1.268-3-2.407 0-.553-.447-1-1-1s-1 .447-1 1c0 2.267 2.129 4.087 5 4.435v1.065c0 .553.447 1 1 1s1-.447 1-1v-1.065c2.871-.348 5-2.168 5-4.435 0-2.739-2.605-3.653-5-4.277zm-5-2.723c0-1.139 1.3-2.12 3-2.407v4.609c-1.884-.527-3-1.065-3-2.202zm5 9.407v-4.609c1.884.527 3 1.065 3 2.202s-1.3 2.12-3 2.407z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 47c-9.374 0-17-7.626-17-17s7.626-17 17-17 17 7.626 17 17-7.626 17-17 17zm0-32c-8.271 0-15 6.729-15 15s6.729 15 15 15 15-6.729 15-15-6.729-15-15-15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostControl);
export default __webpack_public_path__ + "static/media/cost-control.f5187aa061d5f4943a7910aa6774844d.svg";
export { ForwardRef as ReactComponent };